import { Tabs, Tooltip } from '@mantine/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { ClaimTabItem } from '../../../types/tabs'
import classes from './ClaimTabs.module.css'
export type { ClaimTabItem } from '../../../types/tabs'

export interface ClaimTabsProps {
  value: string
  tabs?: ClaimTabItem[]
  onTabChange: (value: string | null) => void
}

// Root and panel stretch into the remaining pane height so a tab can centre its empty
// state vertically. Inline rather than in ClaimTabs.module.css: Mantine's styles.css is
// imported after this module, so its `display: block` on the Tabs root would win.
const STRETCH = { flex: 1, display: 'flex', flexDirection: 'column' } as const
const STRETCH_STYLES = { root: STRETCH, panel: STRETCH }

export function ClaimTabs({ tabs = [], value, onTabChange }: Readonly<ClaimTabsProps>) {
  const hasMatchingTab = tabs.some((tab) => tab.value === value)
  const resolvedValue = hasMatchingTab ? value : (tabs[0]?.value ?? null)

  return (
    <Tabs
      value={resolvedValue}
      onChange={(tab) => {
        if (tab) onTabChange(tab)
      }}
      keepMounted={false}
      variant="unstyled"
      classNames={classes}
      styles={STRETCH_STYLES}
    >
      <Tabs.List grow>
        {tabs.map((tab) => {
          if (!tab.icon) return null
          return (
            <Tooltip key={tab.value} label={tab.label} className={classes.tooltip}>
              <Tabs.Tab value={tab.value} disabled={tab.disabled} leftSection={<FontAwesomeIcon icon={tab.icon} />}>
                {tab.label}
              </Tabs.Tab>
            </Tooltip>
          )
        })}
      </Tabs.List>

      {tabs.map((tab) =>
        tab.panel ? (
          <Tabs.Panel key={tab.value} value={tab.value}>
            {tab.panel}
          </Tabs.Panel>
        ) : null
      )}
    </Tabs>
  )
}
